module.exports = {
  properties: slug => `/papi/v1/partners/website/properties/${slug}`,
  profile: code => `/papi/v5/partners/${code}/profile/`,
  offers: code => `/papi/v3/partners/${code}/offers/paginated/`,
  reviews: code => `/papi/v1/partners/${code}/reviews/paginated/`,
  reviewMetrics: code => `/papi/v1/partners/${code}/reviews/metrics/`,
  banners: code => `/papi/v2/partners/${code}/banners/recommended/?target=website`,
  products: code => `/papi/v1/partners/${code}/product/paginated/`,
  services: code => `/papi/v1/partners/${code}/service/list/`,
  addReview: code => `/mapi/v1/members/${code}/reviews/website/`,
  generateOtp: () => '/otp/v1/generate',
  addServiceRequest: code => `/papi/v1/partners/${code}/service-request/website/`,
  addMember: () => '/mapi/v1/members/website/enrollment/',
};



// WEBPACK FOOTER //
// ./utils/urls.js